import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from 'react';
import { NeutralColors, SharedColors } from '@fluentui/theme';
import { Text, FontIcon, mergeStyleSets } from '@fluentui/react';
import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
import { ItemsTooltip } from '@shared/components/ItemsTooltip';
import { InternalLink } from '@shared/components/internalLink';
import word from '@shared/images/ProductIcons/icon-word.svg';
import outlook from '@shared/images/ProductIcons/icon-outlook.svg';
import onenote from '@shared/images/ProductIcons/icon-onenote.svg';
import officemetaos from '@shared/images/ProductIcons/OfficeMetaOS.svg';
import teams from '@shared/images/ProductIcons/icon-teams.svg';
import excel from '@shared/images/ProductIcons/icon-excel.svg';
import sharepoint from '@shared/images/ProductIcons/icon-sharepoint.svg';
import viva from '@shared/images/ProductIcons/icon-viva.svg';
import powerpoint from '@shared/images/ProductIcons/icon-powerpoint.svg';
import project from '@shared/images/ProductIcons/icon-project.svg';
import azure from '@shared/images/ProductIcons/icon-azure.svg';
import saas from '@shared/images/ProductIcons/web-apps.svg';
import dynamics365Marketing from '@shared/images/ProductIcons/dynamics-365-marketing.svg';
import dynamics365Commerce from '@shared/images/ProductIcons/dynamics-365-commerce.svg';
import dynamics365SupplyChainManagment from '@shared/images/ProductIcons/dynamics-365-supply-chain-management.svg';
import dynamics365ForFinanceAndOperations from '@shared/images/ProductIcons/dynamics-365-for-finance-and-operations.svg';
import dynamics365ForSales from '@shared/images/ProductIcons/dynamics-365-for-sales.svg';
import dynamics365BusinessCentral from '@shared/images/ProductIcons/dynamics-365-business-central.svg';
import dynamics365ForCustomerServices from '@shared/images/ProductIcons/dynamics-365-for-customer-services.svg';
import dynamics365ForFieldServices from '@shared/images/ProductIcons/dynamics-365-for-field-services.svg';
import dynamics365ForProjectServiceAutomation from '@shared/images/ProductIcons/dynamics-365-for-project-service-automation.svg';
import dynamics365CustomerInsights from '@shared/images/ProductIcons/dynamics-365-customer-insights.svg';
import dynamics365CustomerVoice from '@shared/images/ProductIcons/dynamics-365-customer-voice.svg';
import dynamics365ProjectOperations from '@shared/images/ProductIcons/dynamics-365-project-operations.svg';
import dynamics365MixedReality from '@shared/images/ProductIcons/dynamics-365-mixed-reality.svg';
import dynamics365HumanResources from '@shared/images/ProductIcons/dynamics-365-human-resources.svg';
import m365AdoptionAndChangeManagement from '@shared/images/ProductIcons/m365-sa-adoption-and-change-management.svg';
import m365CallingForMicrosoftTeams from '@shared/images/ProductIcons/m365-sa-calling-for-microsoft-teams.svg';
import m365CloudSecurity from '@shared/images/ProductIcons/m365-sa-cloud-security.svg';
import m365ComplianceAdvisoryServices from '@shared/images/ProductIcons/m365-sa-compliance-advisory-services.svg';
import m365DeviceDeploymentAndManagement from '@shared/images/ProductIcons/m365-sa-device-deployment-and-management.svg';
import m365FirstlineWorkers from '@shared/images/ProductIcons/m365-sa-firstline-workers.svg';
import m365IdentityAndAccessManagement from '@shared/images/ProductIcons/m365-sa-identity-and-access-management.svg';
import m365InformationProtectionAndGovernance from '@shared/images/ProductIcons/m365-sa-information-protection-and-governance.svg';
import m365InsiderRisk from '@shared/images/ProductIcons/m365-sa-insider-risk.svg';
import m365KnowledgeAndInsights from '@shared/images/ProductIcons/m365-sa-knowledge-and-insights.svg';
import m365MeetingRoomsForMicrosoftTeams from '@shared/images/ProductIcons/m365-sa-meeting-rooms-for-microsoft-teams.svg';
import m365MeetingsForMicrosoftTeams from '@shared/images/ProductIcons/m365-sa-meetings-for-microsoft-teams.svg';
import m365LiveEvents from '@shared/images/ProductIcons/m365-sa-microsoft-365-live-events.svg';
import m365MobileDeviceManagement from '@shared/images/ProductIcons/m365-sa-mobile-device-management.svg';
import m365PowerPlatformForTeams from '@shared/images/ProductIcons/m365-sa-power-platform-for-teams.svg';
import m365TeamsCustomSolutions from '@shared/images/ProductIcons/m365-sa-teams-custom-solutions.svg';
import m365TeamworkDeployment from '@shared/images/ProductIcons/m365-sa-teamwork-deployment.svg';
import m365ThreatProtection from '@shared/images/ProductIcons/m365-sa-threat-protection.svg';
import m365WorkspaceAnalytics from '@shared/images/ProductIcons/m365-sa-workplace-analytics.svg';
import powerBI from '@shared/images/ProductIcons/power-bi.svg';
import powerBIVisuals from '@shared/images/ProductIcons/power-bi-visuals.svg';
import powerAutomate from '@shared/images/ProductIcons/power-automate.svg';
import powerVirtualAgents from '@shared/images/ProductIcons/power-virtual-agents.svg';
import powerapps from '@shared/images/ProductIcons/icon-powerapps.svg';
import powerpages from '@shared/images/ProductIcons/icon-powerpages.svg';
import appServices from '@shared/images/ProductIcons/azure-application.svg';
import azureServices from '@shared/images/ProductIcons/azure-services.svg';
import kubernetesServices from '@shared/images/ProductIcons/container.svg';
import managedService from '@shared/images/ProductIcons/managed-services.svg';
import virtualMachine from '@shared/images/ProductIcons/virtual-machine.svg';
import entraId from '@shared/images/ProductIcons/entra-id.svg';
import classNames from 'classnames';
const iconsMap = {
    word,
    outlook,
    onenote,
    officemetaos,
    teams,
    excel,
    sharepoint,
    viva,
    powerpoint,
    project,
    azure,
    saas,
    // 'power-platform': true,
    // 'dynamics-365': true,
    'dynamics-365-marketing': dynamics365Marketing,
    'dynamics-365-commerce': dynamics365Commerce,
    'dynamics-365-supply-chain-management': dynamics365SupplyChainManagment,
    // 'dynamics-365-for-operations': true,
    'dynamics-365-for-finance-and-operations': dynamics365ForFinanceAndOperations,
    'dynamics-365-for-sales': dynamics365ForSales,
    'dynamics-365-business-central': dynamics365BusinessCentral,
    'dynamics-365-for-customer-services': dynamics365ForCustomerServices,
    'dynamics-365-for-field-services': dynamics365ForFieldServices,
    'dynamics-365-for-project-service-automation': dynamics365ForProjectServiceAutomation,
    'dynamics-365-customer-insights': dynamics365CustomerInsights,
    'dynamics-365-customer-voice': dynamics365CustomerVoice,
    'dynamics-365-project-operations': dynamics365ProjectOperations,
    // 'dynamics-365-project-services': true,
    'dynamics-365-mixed-reality': dynamics365MixedReality,
    'dynamics-365-human-resources': dynamics365HumanResources,
    'm365-sa-adoption-and-change-management': m365AdoptionAndChangeManagement,
    'm365-sa-calling-for-microsoft-teams': m365CallingForMicrosoftTeams,
    'm365-sa-cloud-security': m365CloudSecurity,
    'm365-sa-compliance-advisory-services': m365ComplianceAdvisoryServices,
    'm365-sa-device-deployment-and-management': m365DeviceDeploymentAndManagement,
    'm365-sa-firstline-workers': m365FirstlineWorkers,
    'm365-sa-identity-and-access-management': m365IdentityAndAccessManagement,
    'm365-sa-information-protection-and-governance': m365InformationProtectionAndGovernance,
    'm365-sa-insider-risk': m365InsiderRisk,
    'm365-sa-knowledge-and-insights': m365KnowledgeAndInsights,
    'm365-sa-meeting-rooms-for-microsoft-teams': m365MeetingRoomsForMicrosoftTeams,
    'm365-sa-meetings-for-microsoft-teams': m365MeetingsForMicrosoftTeams,
    'm365-sa-microsoft-365-live-events': m365LiveEvents,
    'm365-sa-mobile-device-management': m365MobileDeviceManagement,
    'm365-sa-power-platform-for-teams': m365PowerPlatformForTeams,
    'm365-sa-teams-custom-solutions': m365TeamsCustomSolutions,
    'm365-sa-teamwork-deployment': m365TeamworkDeployment,
    'm365-sa-threat-protection': m365ThreatProtection,
    'm365-sa-workplace-analytics': m365WorkspaceAnalytics,
    'power-bi': powerBI,
    'power-bi-visuals': powerBIVisuals,
    'power-automate': powerAutomate,
    'power-virtual-agents': powerVirtualAgents,
    powerapps,
    powerpages,
    'azure-services': azureServices,
    container: kubernetesServices,
    'virtual-machine': virtualMachine,
    'entra-id': entraId,
    'azure-application': appServices,
    'managed-services': managedService,
    analytics: azure,
    'app-modernization': azure,
    archive: azure,
    'ai-plus-machine-learning': azure,
    backup: azure,
    'big-data': azure,
    'data-platform': azure,
    'datacenter-management': azure,
    devops: azure,
    'disaster-recovery': azure,
    identity: azure,
    'internet-of-things': azure,
    migration: azure,
    networking: azure,
    security: azure,
    storage: azure
};
const pixelsPerChar = {
    medium: 9,
    smallPlus: 6
};
const firstIconMargin = 2;
const iconSize = 16;
const totalIconMargin = 8;
const totalTextMargin = totalIconMargin;
const dividerSize = iconSize;
const optionalLeftNumberSize = (textSize)=>2 * pixelsPerChar[`${textSize}`];
const minTextSize = (textSize)=>3 * pixelsPerChar[`${textSize}`];
const classStyles = mergeStyleSets({
    icon: [
        {
            display: 'inline-block',
            margin: `0 ${totalIconMargin / 2}px`
        }
    ],
    firstIcon: [
        {
            margin: `0 ${totalIconMargin / 2}px 0 0`
        }
    ],
    divider: [
        {
            fontSize: iconSize,
            color: NeutralColors.gray40
        }
    ],
    hoveredText: [
        {
            margin: `0px ${totalTextMargin / 2}px`,
            color: SharedColors.cyanBlue10,
            textDecoration: 'underline'
        }
    ],
    link: [
        {
            margin: `2px ${totalTextMargin / 2}px`
        }
    ],
    linkText: [
        {
            color: SharedColors.cyanBlue10
        }
    ],
    text: [
        {
            margin: `0px ${totalTextMargin / 2}px`
        },
        {
            color: NeutralColors.gray130
        }
    ]
});
const containerClassName = (wrap)=>mergeStyleSets({
        container: [
            'itemsContainer',
            {
                flexWrap: wrap ? 'wrap' : 'nowrap'
            }
        ]
    });
const sizes = {
    icon: iconSize + totalIconMargin,
    text: (length, textSize)=>length * pixelsPerChar[`${textSize}`] + totalTextMargin
};
export const ItemsContainerIcon = ({ itemType, className = classStyles.icon })=>/*#__PURE__*/ _jsx("img", {
        src: iconsMap[`${itemType}`],
        width: iconSize,
        height: iconSize,
        alt: `${itemType} product icon`,
        className: className
    });
export const ItemsContainerDivider = ()=>/*#__PURE__*/ _jsx(FontIcon, {
        iconName: "Separator",
        className: classStyles.divider
    });
export const ItemsContainerText = ({ text, hovered = false, textSize = 'medium' })=>{
    const classes = classNames({
        [classStyles.hoveredText]: hovered
    });
    return /*#__PURE__*/ _jsx(Text, {
        variant: textSize,
        className: hovered ? classes : classStyles.text,
        children: text
    });
};
export const ItemsContainerLinkText = ({ entityId, type, text, hovered, hrefCallback, logOnClick, dataBiId, textSize = 'medium' })=>{
    return hrefCallback ? /*#__PURE__*/ _jsx(InternalLink, {
        href: hrefCallback(entityId),
        additionalCommand: logOnClick ? ()=>logOnClick(type) : null,
        "data-bi-id": dataBiId,
        "data-bi-name": entityId,
        "data-bi-view": Constants.Telemetry.TemplateName.SaaSBundle,
        "data-bi-area": Constants.Telemetry.AreaName.AppDetails,
        accEnabled: true,
        className: classStyles.link,
        children: /*#__PURE__*/ _jsx(Text, {
            className: classStyles.linkText,
            variant: textSize,
            children: text
        })
    }) : /*#__PURE__*/ _jsx(ItemsContainerText, {
        text: text,
        textSize: textSize,
        hovered: hovered
    });
};
export const ItemsContainerComponent = ({ items, logOnClick, hrefCallback, tooltipTitle, textSize = 'medium', wrap = false, withText = false, withTooltip = false, dataBiId = 'View AddIn', withDivider = true, linkedAddIns = null, linkedWebApps = null })=>{
    var _ref_current;
    const ref = useRef(null);
    const [elementWidth, setElementWidth] = useState((ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.clientWidth) || 0);
    const onResize = ()=>{
        if (ref.current) {
            setElementWidth(ref.current.clientWidth);
        }
    };
    useEffect(()=>setElementWidth(ref.current.clientWidth), []);
    useEffect(()=>{
        var _getWindow;
        (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.addEventListener('resize', onResize);
        return ()=>{
            var _getWindow;
            (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.removeEventListener('resize', onResize);
        };
    }, []);
    const insertEllipsis = (itemIndex, productIndex, elements, productsNumber)=>{
        let leftNumber = productsNumber - productIndex;
        if (itemIndex > 0) {
            elements.push(/*#__PURE__*/ _jsx(ItemsContainerText, {
                text: "...",
                textSize: textSize,
                hovered: withTooltip
            }, `${itemIndex}_ellipsis`));
            leftNumber -= 1;
        }
        if (leftNumber > 0) elements.push(/*#__PURE__*/ _jsx(ItemsContainerText, {
            text: `+${leftNumber}`,
            textSize: textSize,
            hovered: withTooltip
        }, `${itemIndex}_ellipsis2`));
        return elements;
    };
    const renderElements = ()=>{
        const productsCount = items.length;
        const shouldAddLeftNumber = productsCount > 1;
        const additionalLeftNumberSize = shouldAddLeftNumber ? optionalLeftNumberSize(textSize) : 0;
        const maxWidth = wrap ? Infinity : elementWidth - additionalLeftNumberSize;
        const elementsToRender = [];
        let currentWidth = 0;
        for(let productIndex = 0; productIndex < productsCount; productIndex++){
            const icons = items[`${productIndex}`].icons;
            const lastProduct = productIndex >= productsCount - 1;
            for(let itemIndex = 0; itemIndex < icons.length; itemIndex++){
                const lastType = items[`${productIndex}`].urlKey ? itemIndex === icons.length - 1 : true;
                const shouldAddDivider = itemIndex === 0 && !lastProduct && withDivider;
                let additionalSize = shouldAddDivider ? dividerSize : 0;
                if (currentWidth + sizes.icon + additionalSize < maxWidth) {
                    currentWidth += sizes.icon + additionalSize;
                    if (!withDivider && productIndex === 0) {
                        elementsToRender.push(/*#__PURE__*/ _jsx(ItemsContainerIcon, {
                            itemType: icons[`${itemIndex}`],
                            className: classStyles.firstIcon
                        }, `${productIndex}_${itemIndex}`));
                        additionalSize -= firstIconMargin;
                    } else {
                        elementsToRender.push(/*#__PURE__*/ _jsx(ItemsContainerIcon, {
                            itemType: icons[`${itemIndex}`]
                        }, `${productIndex}_${itemIndex}`));
                    }
                    if (lastType) {
                        const productName = items[`${productIndex}`].title;
                        const productNameLength = sizes.text(productName.length, textSize);
                        const totalMaxWidth = lastProduct ? maxWidth + additionalLeftNumberSize : maxWidth;
                        const totalProductNameLength = withDivider ? productNameLength : productNameLength + totalTextMargin / 2;
                        if (withText) {
                            if (currentWidth + minTextSize(textSize) <= totalMaxWidth) {
                                if (currentWidth + productNameLength > totalMaxWidth) {
                                    const leftNumber = productsCount - productIndex;
                                    // if we cant push the whole product name, then remove the icon and add +1
                                    elementsToRender.pop();
                                    elementsToRender.push(/*#__PURE__*/ _jsx(ItemsContainerText, {
                                        text: `+${leftNumber}`,
                                        textSize: textSize,
                                        hovered: withTooltip
                                    }, `${items[`${productIndex}`].urlKey}_linkText3`));
                                    return elementsToRender;
                                } else {
                                    elementsToRender.push(/*#__PURE__*/ _jsx(ItemsContainerLinkText, {
                                        entityId: items[`${productIndex}`].urlKey,
                                        type: icons[0],
                                        text: productName,
                                        textSize: textSize,
                                        hrefCallback: hrefCallback,
                                        logOnClick: logOnClick,
                                        dataBiId: dataBiId
                                    }, `${items[`${productIndex}`].urlKey}_${productIndex}_linkText`));
                                }
                                currentWidth += totalProductNameLength;
                            } else {
                                elementsToRender.push(/*#__PURE__*/ _jsx(ItemsContainerText, {
                                    text: "...",
                                    textSize: textSize,
                                    hovered: withTooltip
                                }, `${productIndex}_linkText2`));
                                if (lastProduct) return elementsToRender;
                                const leftNumber = productsCount - productIndex - 1;
                                if (leftNumber > 0) elementsToRender.push(/*#__PURE__*/ _jsx(ItemsContainerText, {
                                    text: `+${leftNumber}`,
                                    textSize: textSize,
                                    hovered: withTooltip
                                }, `${items[`${productIndex}`].urlKey}_linkText3`));
                                return elementsToRender;
                            }
                        }
                        if (!lastProduct && withDivider) elementsToRender.push(/*#__PURE__*/ _jsx(ItemsContainerDivider, {}, `${items[`${productIndex}`].urlKey}_linkDivider`));
                    }
                } else {
                    return insertEllipsis(itemIndex, productIndex, elementsToRender, productsCount);
                }
            }
        }
        if (linkedWebApps) {
            elementsToRender.push(linkedWebApps);
        }
        if (linkedAddIns) {
            elementsToRender.push(linkedAddIns);
        }
        return elementsToRender.map((element, index)=>/*#__PURE__*/ _jsx(React.Fragment, {
                children: element
            }, index));
    };
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: "itemsRootContainer",
        children: withTooltip ? /*#__PURE__*/ _jsx(ItemsTooltip, {
            title: tooltipTitle,
            items: items,
            children: /*#__PURE__*/ _jsx("div", {
                className: containerClassName(wrap).container,
                children: renderElements()
            })
        }) : /*#__PURE__*/ _jsx("div", {
            className: containerClassName(wrap).container,
            children: renderElements()
        })
    });
};
